import { AlertOctagon } from 'lucide-react';

import { StateButton, StateLink, StatePage } from './StatePage';

interface Props {
  details?: string | undefined;
}

export function ServerErrorPage({ details }: Props) {
  return (
    <StatePage
      code="500"
      icon={AlertOctagon}
      tone="danger"
      title="משהו השתבש"
      body="נתקלנו בשגיאה לא צפויה. נסה לרענן את הדף — אם זה נמשך, פנה לתמיכה."
      details={details}
      primary={
        <StateButton variant="primary" onClick={() => { window.location.reload(); }}>
          רענן את הדף
        </StateButton>
      }
      secondary={<StateLink variant="secondary" to="/">חזור לדף הבית</StateLink>}
    />
  );
}
